export default "__VITE_ASSET__CHpG6sXL__"